module.exports = __webpack_public_path__ + "img/arrow-right-end.9654a814.svg";